module.exports = __webpack_public_path__ + "img/bidsTakeProfit.ac9a6114.svg";